<div class="help_icon">
	<a routerLink="/support"><img src="./assets/image/icons/help.png" width="50"></a>
</div> 

